import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import Navigation from '../../Components/Navbar';
import api from '../../Components/Api/Api';
import Spinner from '../../Components/Spinner';
import './index.scss';
import { UserContext } from '../../context/UserContext';

const Extratocliente = () => {
  const {user} = useContext(UserContext)
  const [vendas, setVendas] = useState<any>([]);
  const [titulos, setTitulos] = useState<any>([]);
  const [produtos, setProdutos] = useState<any>([]);
  const [showLoading, setShowLoading] = useState(false);
  const [page, setPage] = useState(0)
  const [perpage, setPerpage] = useState(10)
  const [page2, setPage2] = useState(0)
  const [perpage2, setPerpage2] = useState(10)  
  const [linhastotal, setLinhastotal] = useState(0)
  const [linhastitulos, setLinhastitulos] = useState(0)
  const [atualizar, setAtualizar] = useState(false) 
  const [atualizatitulo, setAtualizatitulo] = useState(false)
  const [limite, setLimite] = useState(0)
  const [vlaberto, setVlaberto] = useState(0)
  const [saldocredito, setSaldocredito] = useState(0)
  const [showmodal, setShowmodal] = useState(false)
  const [consultacliente, setConsultacliente] = useState('')
  const [cgc,setCGC] = useState('')
  const [codigo, setCodigo] = useState('')
  const [loja, setLoja] = useState('')
  const [nome, setNome] = useState('')  
  const [ShowBuscaclientes, setShowBuscaclientes] = useState(false)
  let [clientes, setClientes] = useState<any>([])
  const credentials = btoa(`${user.userRest}:${user.passRest}`); 
  const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
      "User-Agent": "PneusBrasil",
      "Accept": "application/json",
      'Authorization': `Basic ${credentials}`
  } 
  const getdadosvendas = (codigocli: string) => {
    setShowLoading(true);
    api.get('Extratoclivendas?cliente='+codigocli+'&page='+page+'&perpage='+perpage,{headers})
      .then(response => {
        if (response.data.Vendas.length > 0) {
          getdadostitulos(codigocli)
          setVendas(response.data.Vendas);
          setLinhastotal(response.data.Vendas[0]['linhas']);
          setAtualizar(false)
          setShowLoading(false);
        } else {
          //alert('Vendas não encontradas!');
        }
      });
  };
  const getdadostitulos = (codcli: string) => {
    setShowLoading(true);
    api.get('Extratoclititulos?cliente='+codcli+'&page='+page2+'&perpage='+perpage2,{headers})
      .then(response => {
        if (response.data.Titulos.length > 0) {
          setTitulos(response.data.Titulos);
          setLinhastitulos(response.data.Titulos[0]['linhas']);
          setLimite(response.data.Titulos[0]['limite'])
          let saldo = 0
          for (let i = 0; i < response.data.Titulos.length; i++) { 
            saldo = saldo + response.data.Titulos[0]['saldo']
          } 
          setVlaberto(saldo)
          setSaldocredito(response.data.Titulos[0]['limite'] - saldo)
          setAtualizatitulo(false)
          setShowLoading(false);
        } else {
          //alert('Vendas não encontradas!');
          setTitulos([]);
          setLinhastitulos(0);
          setLimite(0) 
          setVlaberto(0)
          setSaldocredito(0) 
          setAtualizatitulo(false)
          setShowLoading(false);                  
        }
      });
  };
  const getprodutos = (filial: string, nota: string, serie: string) => {
    setShowLoading(true);
    api.get('Extratocliprodutos?filial='+filial+'&nota='+nota+'&serie='+serie,{headers})
      .then(response => {
        if (response.data.Produtos.length > 0) {
          setProdutos(response.data.Produtos);
          setShowLoading(false);
          setShowmodal(true)
        } else {
          //alert('Vendas não encontradas!');
        }
      });
  };
  const Apigetcliente = (nTp: number) => {
    if (consultacliente !== ''){
      setShowLoading(true);
        api.get('Dadoscliente?filial=01&consulta='+consultacliente+'&tpconsulta='+nTp,{headers})
        .then(response => {
            if (response.data.Dadoscliente.length > 0 ){ 
              //console.log(response.data.Dadoscliente) 
                if (nTp === 1){
                    setCodigo(response.data.Dadoscliente[0]['codigo'])
                    setLoja(response.data.Dadoscliente[0]['loja'])  
                    setNome(response.data.Dadoscliente[0]['nome']) 
                    setCGC(response.data.Dadoscliente[0]['cgc'])
                    setAtualizar(true)
                    //getdadosvendas(response.data.Dadoscliente[0]['codigo'])
                    setShowLoading(false);     
                }else{
                    setClientes(response.data.Dadoscliente)
                    setConsultacliente('')
                    setAtualizar(true)
                    setShowLoading(false);     
                }       
            }else{
                setCodigo('Cliente não cadastrado!')
                setLoja('')  
                setNome('') 
                alert('Cliente não encontrado')                 
                setShowLoading(false);  
            }                                   
        }); 
    }      
  };
  const paginacao = (sentido: string, op: string) => { 
    if(op === '1') {   
      if(sentido === 'next' && page < (linhastotal - perpage)){
        //console.log(sentido, ' - ',page + perpage)
        setPage(page + perpage)
        setAtualizar(true)
      }
      if(sentido === 'back' && page > 0){
        //console.log(sentido, ' - ',page - perpage)
        setPage(page - perpage)
        setAtualizar(true)
      }
    } else if (op === '2'){
      if(sentido === 'next' && page2 < (linhastitulos - perpage2)){
        console.log(sentido, ' - ',page2 + perpage2)
        setPage2(page2 + perpage2)
        //getdadostitulos(codigo)
        setAtualizatitulo(true)
        console.log(codigo)
      }
      if(sentido === 'back' && page2 > 0){
        console.log(sentido, ' - ',page2 - perpage2)
        setPage2(page2 - perpage2)
        //getdadostitulos(codigo)
        setAtualizatitulo(true)
        console.log(codigo)
      }      
    }   
  }
  const modalclose = () => {
    setShowmodal(false)             
  }; 
  const upcliente = (e: any) =>{
    setConsultacliente(e.target.value.toUpperCase( ))
  }; 
  
  const getBuscacliente = (cpf: string,codigocli: string, loja: string, nome: string) => {
    setCGC(cpf);
    setCodigo(codigocli)
    setLoja(loja)  
    setNome(nome)  
    setShowBuscaclientes(false)  
    setAtualizar(true)   
  };  
  
  useEffect(() => {
    const el = document.querySelectorAll("div[id=divmodal]");  
    const cli = document.querySelectorAll("div[id=divclientes]");
    if (ShowBuscaclientes === true){
      cli[0].setAttribute('style', 'display:block');
    }else{
      cli[0].setAttribute('style', 'display:none');
    };         
    if (showmodal === true){
      el[0].setAttribute('style', 'display:block');
    }else{
      el[0].setAttribute('style', 'display:none');
    };      
    if(atualizar){
      getdadosvendas(codigo)
    };
    if(atualizatitulo){
      getdadostitulos(codigo)
    } 

  });

  return (
    <>
      <Navigation />
      <Container>
        <h1>Extrato Cliente</h1>
        <div>                  
          <div>
            <input className="mt-2 w-75" value={consultacliente} onChange={(e) => {upcliente(e)}} placeholder="Digite o CPF ou CNPJ"></input>
            <button className="btn btn-info btn-sm mb-1" type="button" onClick={() => Apigetcliente(1)}>Buscar</button>  
            <button className="btn btn-success btn-sm mb-1 ms-2" type="button" onClick={() => setShowBuscaclientes(true)}>Pesquisar</button>                                                   
          </div> 
          <div>
              <h6 className="m-0">{codigo}-{loja} - {nome} - CGC: {cgc}</h6>             
          </div>                       
        </div>         
        <div>
            <h3>Notas</h3>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Emp Fil</th>
                  <th>Nota</th>
                  <th>Série</th>
                  <th>Emissao</th>
                  <th className='vendedor'>Vendedor</th>
                  <th>Total</th>
                  <th>Desconto</th>
                  <th>Liquido</th>
                  <th>For pag</th>
                  <th className='condpag'>Condicao pag.</th>
                </tr>
              </thead>
              <tbody>
                {vendas.map((nota: any, index: number) => (
                  <tr key={index} onClick={() => {getprodutos((nota.filial),(nota.nota),(nota.serie))}}>
                    <td>{nota.emp}{nota.filial}</td>
                    <td>{nota.nota}</td>
                    <td>{nota.serie}</td>
                    <td>{nota.data}</td>
                    <td className='vendedor'>{nota.vendedor}</td>
                    <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(nota.vltotal)}</td> 
                    <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(nota.desconto)}</td>
                    <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(nota.vlliquido)}</td>
                    <td>{nota.formpag}</td>
                    <td className='condpag'>{nota.codpag}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          {vendas.length > 0 ? 
            (
              <div className='mt-2'>
                <button onClick={() => {paginacao('next','1')}} className='btn btn-outline-success'>Proxima</button>
                <button onClick={() => {paginacao('back','1')}}className='ms-2 btn btn-outline-primary'>Anterior</button>
                <label className='ms-4'>Linhas {page} de {linhastotal}</label>
              </div>         
            ) : ('')
          }        
        </div>
        <div className='mt-4'>
              <h3>Titulos</h3>            
          <Row className='subtotais'>
            <Col>
              <h6>Limite: R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(limite)}</h6>
            </Col>
            <Col>
              <h6 className='ms-2'>Saldo: R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(vlaberto)}</h6>
            </Col>            
            <Col>
              <h6 className='ms-2'>Limite Atual: R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(saldocredito)}</h6>
            </Col>
          </Row>
        <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Emp Fil</th>
                  <th>Nota</th>
                  <th>Série</th>
                  <th>Parc.</th>
                  <th>Emissao</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                  <th>Saldo</th>          
                </tr>
              </thead>
              <tbody>
                {titulos.map((titulo: any, index: number) => (
                  <tr key={index}>
                    <td>{titulo.emp}{titulo.filial}</td>
                    <td>{titulo.nota}</td>
                    <td>{titulo.serie}</td>
                    <td>{titulo.parcela}</td>
                    <td>{titulo.emissao}</td>
                    <td>{titulo.vencimento}</td>
                    <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(titulo.valor)}</td> 
                    <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(titulo.saldo)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          {vendas.length > 0 ? 
            (
              <div className='mt-2'>
                <button onClick={() => {paginacao('next','2')}} className='btn btn-outline-success'>Proxima</button>
                <button onClick={() => {paginacao('back','2')}}className='ms-2 btn btn-outline-primary'>Anterior</button>
                <label className='ms-4'>Linhas {page2} de {linhastitulos}</label>
              </div>         
            ) : ('')
          }                  
        </div>
        <div id="divmodal" className="modal show" >
                            <Modal
                              show={showmodal}
                              onHide={() => (modalclose())}
                            >
                            <Modal.Header closeButton>
                              <Modal.Title>Produtos</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                    <Row className="mb-2">
                                    <Table striped bordered hover responsive>
                                      <thead>
                                        <tr>
                                          <th>Item</th>
                                          <th>Produto</th>
                                          <th>Descrição</th>
                                          <th>Quantidade</th>
                                          <th>Prc. Tabela</th>
                                          <th>Sub Total</th>
                                          <th>Desconto</th>
                                          <th>Total</th>          
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {produtos.map((produto: any, index: number) => (
                                          <tr key={index}>
                                            <td>{produto.item}</td>
                                            <td>{produto.codprod}</td>
                                            <td>{produto.descpro}</td>
                                            <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(produto.quantidade)}</td>
                                            <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(produto.pctabela)}</td>
                                            <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(produto.subtotal)}</td>
                                            <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(produto.desconto)}</td> 
                                            <td>R$ {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(produto.total)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>                                    
                                    </Row>
                                </Modal.Body>
                            </Modal> 
        </div> 
                {/* busca clientes  */}
                <div id="divclientes" className="modalprcprazo">
                <Modal show={ShowBuscaclientes} onHide={() => (setShowBuscaclientes(false))} >
                <Modal.Header closeButton>
                    <Modal.Title>Busca clientes</Modal.Title>
                </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-2">
                        <div>
                            <input className="mt-2 w-75" value={consultacliente} onChange={(e) => {upcliente(e)}} placeholder="Digite o nome ou razão social"></input>
                            <button className="btn btn-info btn-sm mb-1" type="button" onClick={() => Apigetcliente(2)}>Buscar</button>                                                     
                        </div> 
                        </Row>
                        <Row className="mb-2">
                        <Table striped bordered hover variant="light" responsive className="tabela">
                            <thead>
                                <tr className='col-title'>
                                <th>Codigo</th>
                                <th>Loja</th>
                                <th>Nome ou razaão social</th>    
                                <th>Cgc</th>           
                                </tr>
                            </thead> 
                            <tbody> 
                            {clientes.map((list: any) => (           
                            <tr key={list.id}>
                                <td>{list.codigo}</td>
                                <td>{list.loja}</td>
                                <td>{list.nome}</td>
                                <td onClick={() => getBuscacliente(list.cgc,list.codigo,list.loja,list.nome)}>{list.cgc}</td>
                            </tr>
                            ))}                         
                            </tbody>
                        </Table>                                       
                        </Row>
                    </Modal.Body>
                </Modal>                                            
                </div>               
        <Spinner isLoading={showLoading} /> 
      </Container>
    </>
  );
};

export default Extratocliente;
